export class PriceLabelSection{
    priceLabelSecId: number;
    description: string;
    exampleValue: string;
    propertyMatch: string;
    createdDate: Date;
    organizationId: string;   
}